import React, { useEffect, useState, useRef} from 'react';
import { useAppSelector, useAppDispatch } from '../hooks/storeHooks';
import GetCP from '../apis/ApiCP';
import {
    getAvalCP,
    getAvalMunicipality,
    getAvalState,
    getAvalRFC,
    getAvalObjColonias,
    getAvalColony,
    getValidateAvalRFC,
    getAvalEmail,
    getValidateAvalEmail,
    getAvalCellphone,
    getAvalStreet,
    getAvalNumberHouse,
    getAvalFirstName,
    getAvalSecondName,
    getAvalSecondLastName,
    getAvalFirstLastName,
    getAvalGender,
    getAvalGenderType,
} from '../reducer/slices/DataCotizador';
import { Checkbox, Grid } from '@mui/material';
import {
    ThirdStepContainer,
    TitleThirdStepContainer,
    txtdefault,
} from '../styles/StepsStyles';
import {
    InputDefault,
    InputSelect, 
    NumericInput
} from '../components/Inputs/Inputs';
import { RegexRFCFisica, RegexRFCMoral } from '../utils/constants';
import { validateRFCFisicaConNombre } from '../functions/ValidateSteps';
import { getAnalytics, logEvent } from '@firebase/analytics';
import { blockedPostalCodes } from '../constants/blockedPostalCodes';
import { message } from 'antd';
var validator = require('validator');

const arrayGender: { id: Number, name: String }[] = [
    { id: 0, name: 'Femenino' },
    { id: 1, name: 'Masculino'  }
]
const FiveStepView = () => {
    const lastErrorCP = useRef<string | null>(null);
    const analytics = getAnalytics();
    const dataCotizador = useAppSelector(state => state.DataCotizador);
    const dispatch = useAppDispatch();

    const Size = window.innerHeight < 950 ? "small" : undefined;
    const Spacing = dataCotizador.avalType === 0 ? 2 : window.innerHeight < 950 ? 2 : 4;

    useEffect(() => {
        logEvent(analytics, "view_fifth_screen");
    }, []);

    useEffect(() => {
        if (dataCotizador.avalCP?.length === 5) {
            ValidateCP(dataCotizador.avalCP);
        }
    }, [dataCotizador.avalCP]);

    useEffect(() => {
        if (dataCotizador.avalType === 0 && dataCotizador.avalRFC.length === 13) {
            ValidateRFC(dataCotizador.avalRFC, undefined, undefined, dataCotizador.avalFirstName, dataCotizador.avalSecondName);
        }
    }, [dataCotizador.avalFirstLastName, dataCotizador.avalSecondLastName, dataCotizador.avalFirstName, dataCotizador.avalSecondName]);

    const ValidateRFC = (value: string, overrideFirstLastName?: string, overrideSecondLastName?: string, overrideFirstName?: string, overrideSecondName?: string) => {
        const upper = value.toUpperCase();
        dispatch(getAvalRFC(upper));
        if (!upper) {
            dispatch(getValidateAvalRFC(false));
            return;
        }
        const formatOk = dataCotizador.avalType === 0 ? RegexRFCFisica.test(upper) : RegexRFCMoral.test(upper);
        if (!formatOk) {
            setAvalRFCHelperText('RFC No válido');
            dispatch(getValidateAvalRFC(false));
            return;
        }
        if (dataCotizador.avalType === 0 && upper.length === 13) {
            const pat = overrideFirstLastName ?? dataCotizador.avalFirstLastName;
            const mat = overrideSecondLastName ?? dataCotizador.avalSecondLastName;
            const firstName = overrideFirstName !== undefined ? overrideFirstName : dataCotizador.avalFirstName;
            const secondName = overrideSecondName !== undefined ? overrideSecondName : dataCotizador.avalSecondName;
            const check = validateRFCFisicaConNombre(upper, pat, mat, 'el principal accionista/aval', firstName, secondName);
            setAvalRFCHelperText(check.errorMsg || 'RFC No válido');
            dispatch(getValidateAvalRFC(check.valid));
        } else {
            setAvalRFCHelperText('RFC No válido');
            dispatch(getValidateAvalRFC(formatOk));
        }
    }

    const ValidateEmail = (value: string) => {
        const validate = validator.isEmail(value);
        dispatch(getAvalEmail(value));
        dispatch(getValidateAvalEmail(validate));
    }

    const ValidateCP = async (value: string) => {
        dispatch(getAvalCP(value));

        if (value.length !== 5) {
            lastErrorCP.current = null;
            dispatch(getAvalState(""));
            dispatch(getAvalMunicipality(""));
            return;
        }
        
        if (value.length === 5) {
            if (blockedPostalCodes.has(value)) {

                if (lastErrorCP.current !== value) {
                    message.destroy();
                    message.error("Actualmente no tenemos cobertura en este código postal");
                    lastErrorCP.current = value;
                }

                dispatch(getAvalState(""));
                dispatch(getAvalMunicipality(""));
                return;
            }

            lastErrorCP.current = null;
            GetCP(value).then((res: any) => {
                dispatch(getAvalState(res.items.suburbs[0].State));
                dispatch(getAvalMunicipality(res.items.suburbs[0].Municipality));
                
                const formattedSuburbs = res.items.suburbs.map((suburb: any) => {
                    return {
                        id: suburb.Id,
                        name: suburb.Name
                    };
                });
                dispatch(getAvalObjColonias(formattedSuburbs));
            }).catch((error: any) => console.log(error));
        }
    };
    const [avalData, setAvalData] = useState<boolean | undefined>(undefined);
    const [avalRFCHelperText, setAvalRFCHelperText] = useState<string>('RFC No válido');
    const onChangeColony = (value: string) => dispatch(getAvalColony(value));
    const onChangeStreet = (value: string) => dispatch(getAvalStreet(value.toUpperCase()));
    const onChangeNumberHouse = (value: string) => dispatch(getAvalNumberHouse(value));
    const onChangeFirstName = (value: string) => dispatch(getAvalFirstName(value.toUpperCase()));
    const onChangeSecondName = (value: string) => dispatch(getAvalSecondName(value.toUpperCase()));
    const onChangeFirstLastName = (value: string) => dispatch(getAvalFirstLastName(value.toUpperCase()));
    const onChangeSecondLastName = (value: string) => dispatch(getAvalSecondLastName(value.toUpperCase()));
    const Validate = () => { }
    const setGenderAvalType = (value: number) => {
        dispatch(getAvalGenderType(value));
        if (value === 0) {
          dispatch(getAvalGender('F'));
        } else{
          dispatch(getAvalGender('M'));
        }
      };

    const onChangeSameData = (event: any) =>{
        const isChecked = event.target.checked;
        setAvalData(isChecked)
        if (isChecked){
            dispatch(getAvalFirstName(dataCotizador.legalRepresentativeFirstName));
            dispatch(getAvalSecondName(dataCotizador.legalRepresentativeSecondName));
            dispatch(getAvalFirstLastName(dataCotizador.legalRepresentativeFirstLastName));
            dispatch(getAvalSecondLastName(dataCotizador.legalRepresentativeSecondLastName));
            // Se pasan los apellidos del representante como override porque Redux aún no los
            // ha actualizado cuando se llama ValidateRFC (los dispatches son asíncronos)
            ValidateRFC(
                dataCotizador.legalRepresentativeRFC,
                dataCotizador.legalRepresentativeFirstLastName,
                dataCotizador.legalRepresentativeSecondLastName
            );
            // Validar el correo electrónico antes de asignarlo
            const legalRepresentativeEmail = dataCotizador.legalRepresentativeEmail;
            const isEmailValid = validator.isEmail(legalRepresentativeEmail);
            if (isEmailValid) {
                dispatch(getAvalEmail(legalRepresentativeEmail));
                dispatch(getValidateAvalEmail(isEmailValid));
            }
            dispatch(getAvalCellphone(dataCotizador.legalRepresentativeCellphone));
        }else{
            dispatch(getAvalFirstName(''));
            dispatch(getAvalSecondName(''));
            dispatch(getAvalFirstLastName(''));
            dispatch(getAvalSecondLastName(''));
            dispatch(getAvalRFC(''));
            dispatch(getValidateAvalRFC(false));
            dispatch(getAvalEmail(''));
            dispatch(getAvalCellphone(''));
        }
    }

    return (
        <div style={ThirdStepContainer}>
            <p style={TitleThirdStepContainer}>Información del principal accionista / Aval</p>
            <Grid container xs={12} sm={6} style={{marginBottom: 30}} >
            <Checkbox
                  checked={avalData}
                  onChange={onChangeSameData}
                  value={avalData}
              /> 
            <p style={{...txtdefault, marginTop: 10}}>Mismos datos que Representante Legal </p>
            </Grid>
            <Grid container spacing={Spacing} >
                <Grid item xs={12} sm={6}>
                    <InputDefault
                        label='RFC'
                        maxlength={13}
                        value={dataCotizador.avalRFC}
                        onChange={ValidateRFC}
                        validate={dataCotizador.validateAvalRFC}
                        helperText={avalRFCHelperText}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputDefault
                        label='Primer Nombre'
                        onChange={onChangeFirstName}
                        value={dataCotizador.avalFirstName}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputDefault
                        label='Segundo Nombre'
                        onChange={onChangeSecondName}
                        value={dataCotizador.avalSecondName} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputDefault
                        label='Primer Apellido'
                        onChange={onChangeFirstLastName}
                        value={dataCotizador.avalFirstLastName} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputDefault
                        label='Segundo Apellido'
                        onChange={onChangeSecondLastName}
                        value={dataCotizador.avalSecondLastName} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputSelect label='Genero' value={dataCotizador.avalGenderType} setValue={setGenderAvalType} listItems={arrayGender} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputDefault
                        label='Correo electrónico'
                        onChange={ValidateEmail}
                        validate={dataCotizador.validateAvalEmail}
                        helperText="Correo no válido"
                        value={dataCotizador.avalEmail} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputDefault
                        onChange={(value: string) => dispatch(getAvalCellphone(value))}
                        value={dataCotizador.avalCellphone}
                        isOnlyNumber
                        label="Teléfono" />
                </Grid>
                <Grid item xs={12}>
                    <p style={TitleThirdStepContainer} >Datos de domicilio fiscal</p>
                </Grid>
                
                <Grid item xs={12} sm={4}>
                    <NumericInput
                        label='CP'
                        onChange={ValidateCP}
                        isOnlyNumber
                        maxlength={5}
                        value={dataCotizador.avalCP} />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <InputDefault
                        label='Estado'
                        onChange={Validate}
                        disabled
                        value={dataCotizador.avalState} />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <InputDefault
                        label='Municipio'
                        onChange={Validate}
                        disabled
                        value={dataCotizador.avalMunicipality} />
                </Grid>
            </Grid>
            <p style={{...txtdefault, marginTop: '3vh'}}>El aval deberá tener entre 25 años y 70 años</p>
            <div style={{ marginTop: 50}}>
                {dataCotizador.userType === 0 &&(
                    <p style={{ ...txtdefault, marginBottom: 10}}>
                        A continuación, es necesario autorizar las consultas al buró de crédito, 
                        tanto de la persona moral como de la persona física o aval, según aplique, 
                        que haya sido registradas en este proceso de preaprobación. Para ello, 
                        enviaremos a su medio de contacto elegido (correo o celular) un único 
                        número de identificación personal (NIP) con el cual podrá autorizar a 
                        FinBe ABC realizar ambas consultas.
                    </p>
                )}
                
            </div>
        </div>
    )
}

export default FiveStepView;